var render = function render(){
  var _vm$mostRecentBlogPos, _vm$mostRecentBlogPos2, _vm$mostRecentBlogPos3, _vm$mostRecentBlogPos4, _vm$mostRecentNewsPos, _vm$mostRecentNewsPos2, _vm$mostRecentNewsPos3, _vm$mostRecentNewsPos4;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "main-content"
  }, [_c('PageHeader', [_c('PageHeaderTitleContent', [_c('TitleTextContent', {
    attrs: {
      "titleText": 'Cyber Corner'
    }
  }), _c('div', {
    staticClass: "cyber-corner-header-title mt-2 mt-md-0 mt-lg-0 mt-xl-0"
  }, [_c('div', {
    staticClass: "d-flex justify-content-center align-items-center cyber-corner-title-text mt-3"
  }, [_vm._v(" Welcome to the Cyber Corner where you can learn about the world through the lens of experts in the field ")]), _c('div', {
    staticClass: "d-flex justify-content-center align-items-center cyber-corner-title-text mt-2 mt-md-5 mt-lg-5 mt-xl-5"
  }, [_vm._v(" Read our news and blogs below ")])])], 1)], 1), _c('section', {
    staticClass: "section p-0 mt-5 mb-4 section-content"
  }, [_c('div', {
    staticClass: "contain-fluid px-xs-1 px-md-5 px-lg-5 mb-lg-4 mb-xl-4"
  }, [_c('div', {
    staticClass: "row m-0"
  }, [_c('div', {
    staticClass: "cyber-corner-container col-12 col-md-6 col-lg-6 col-xl-6 py-0 pl-md-0 pl-lg-0 pl-xl-0 d-flex justify-content-center"
  }, [_c('div', {
    staticClass: "cyber-corner-item"
  }, [_vm._m(0), _c('router-link', {
    staticClass: "cyber-corner-recent-item-image d-flex justify-content-center",
    attrs: {
      "to": {
        name: 'blogdetail',
        query: {
          id: (_vm$mostRecentBlogPos = _vm.mostRecentBlogPost) === null || _vm$mostRecentBlogPos === void 0 ? void 0 : _vm$mostRecentBlogPos.id,
          isRecentBlogs: true
        }
      }
    }
  }, [_c('div', {
    staticClass: "item-image-container"
  }, [_c('img', {
    staticClass: "item-image",
    attrs: {
      "src": (_vm$mostRecentBlogPos2 = _vm.mostRecentBlogPost) === null || _vm$mostRecentBlogPos2 === void 0 ? void 0 : _vm$mostRecentBlogPos2.mainImage,
      "alt": "",
      "width": "100%",
      "height": "100%"
    }
  }), _c('div', {
    staticClass: "item-image-overlay",
    style: {
      'backgroundColor': `rgba(0, 0, 0, 0.7)`
    }
  }), _c('div', {
    staticClass: "item-title limit-lines-4 mb-3 mb-md-5 mb-lg-5 mb-xl-5"
  }, [_vm._v(" " + _vm._s((_vm$mostRecentBlogPos3 = _vm.mostRecentBlogPost) === null || _vm$mostRecentBlogPos3 === void 0 ? void 0 : _vm$mostRecentBlogPos3.title) + " ")])])]), _c('div', {
    staticClass: "w-100 d-flex justify-content-center"
  }, [_c('div', {
    staticClass: "item-headline p-2 limit-lines-5 text-center"
  }, [_vm._v(" " + _vm._s((_vm$mostRecentBlogPos4 = _vm.mostRecentBlogPost) === null || _vm$mostRecentBlogPos4 === void 0 ? void 0 : _vm$mostRecentBlogPos4.headLine) + " ")])]), _c('div', {
    staticClass: "row m-0 mt-3"
  }, [_c('div', {
    staticClass: "col-12 p-0 d-flex justify-content-center align-items-center mt-2 mt-md-0 mt-lg-0 mt-xl-0"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'blog'
      }
    }
  }, [_c('v-btn', {
    attrs: {
      "rounded": "",
      "large": "",
      "dark": "",
      "color": '#424EC4'
    }
  }, [_vm._v(" Read All Recent Blogs ")])], 1)], 1)])], 1)]), _c('div', {
    staticClass: "cyber-corner-container col-12 col-md-6 col-lg-6 col-xl-6 py-0 pr-md-0 pr-lg-0 pr-xl-0 mt-4 mt-md-0 mt-lg-0 mt-xl-0 d-flex justify-content-center"
  }, [_c('div', {
    staticClass: "cyber-corner-item"
  }, [_vm._m(1), _c('router-link', {
    staticClass: "cyber-corner-recent-item-image d-flex justify-content-center",
    attrs: {
      "to": {
        name: 'newsdetail',
        query: {
          id: (_vm$mostRecentNewsPos = _vm.mostRecentNewsPost) === null || _vm$mostRecentNewsPos === void 0 ? void 0 : _vm$mostRecentNewsPos.id,
          isRecentNews: true
        }
      }
    }
  }, [_c('div', {
    staticClass: "item-image-container"
  }, [_c('img', {
    staticClass: "item-image",
    attrs: {
      "src": (_vm$mostRecentNewsPos2 = _vm.mostRecentNewsPost) === null || _vm$mostRecentNewsPos2 === void 0 ? void 0 : _vm$mostRecentNewsPos2.article.largeImageURL,
      "alt": "",
      "width": "100%",
      "height": "100%"
    }
  }), _c('div', {
    staticClass: "item-image-overlay",
    style: {
      'backgroundColor': `rgba(0, 0, 0, 0.7)`
    }
  }), _c('div', {
    staticClass: "item-title limit-lines-4 mb-3 mb-md-5 mb-lg-5 mb-xl-5"
  }, [_vm._v(" " + _vm._s((_vm$mostRecentNewsPos3 = _vm.mostRecentNewsPost) === null || _vm$mostRecentNewsPos3 === void 0 ? void 0 : _vm$mostRecentNewsPos3.article.title) + " ")])])]), _c('div', {
    staticClass: "w-100 d-flex justify-content-center"
  }, [_c('div', {
    staticClass: "item-headline p-2 limit-lines-5 text-center"
  }, [_vm._v(" " + _vm._s((_vm$mostRecentNewsPos4 = _vm.mostRecentNewsPost) === null || _vm$mostRecentNewsPos4 === void 0 ? void 0 : _vm$mostRecentNewsPos4.article.headLine) + " ")])]), _c('div', {
    staticClass: "row m-0 mt-3"
  }, [_c('div', {
    staticClass: "col-12 p-0 d-flex justify-content-center align-items-center mt-2 mt-md-0 mt-lg-0 mt-xl-0"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'news'
      }
    }
  }, [_c('v-btn', {
    attrs: {
      "rounded": "",
      "large": "",
      "dark": "",
      "color": '#424EC4'
    }
  }, [_vm._v(" Read All Recent News ")])], 1)], 1)])], 1)])])])])], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "w-100 d-flex justify-content-center section-title"
  }, [_c('span', [_vm._v("READ OUR NEWEST BLOG")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "w-100 d-flex justify-content-center section-title"
  }, [_c('span', [_vm._v("CATCH UP ON RECENT NEWS")])]);

}]

export { render, staticRenderFns }